import styled from "styled-components";

import Price from "@sso/components/Price/Price";
import { Currency, LicenceType, PricingRule } from "@sso/types";

interface SingleUserPricingProps {
  pricingRules: PricingRule[];
  transactionCurrency: Currency;
  licenceType: LicenceType;
}

const PricingHeader = styled.h4`
  font-size: 1.75rem;
  font-weight: 200;
`;

const SingleUserPricing = ({ pricingRules, transactionCurrency }: SingleUserPricingProps) => {
  const price = pricingRules && pricingRules.length > 0 ? pricingRules[0].transactionCostIncTax : 0;

  return (
    <>
      <PricingHeader>
        <Price currency={transactionCurrency} price={price ?? 0} />
      </PricingHeader>
    </>
  );
};

export default SingleUserPricing;
